import { Injectable } from "@angular/core";
import { LgApplicationPermissionsBase } from "@logex/framework/lg-application";

@Injectable({
    providedIn: "root"
})
export class AdministrationPermissions extends LgApplicationPermissionsBase {
    static readonly read = "ssp_read";
    static readonly edit = "ssp_edit";
    static readonly admin = "ssp_admin";

    static readonly readPermissions = [
        AdministrationPermissions.edit,
        AdministrationPermissions.read
    ];
}
